import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';
import './organization-dropdown-list';

class OrganizationDropdown extends LitEntity {
  static get properties() {
    return {
      dest: { type: String },
      organizations: { type: Array },
      open: { type: Boolean, reflect: true },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
        position: relative;
        user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -webkit-user-select: none;
        --dropdown-width: 300px;
        margin-left: -.25em;
      }
      :host([open]) .org-dropdown-container {
        width: calc(var(--dropdown-width) + 2em);
      }
      .trigger {
        display: inline-block;
        padding: 3px 6px;
        cursor: pointer;
        color: var(--blue-60);
      }
      .trigger:hover {
        color: var(--blue-60);
        background-color: var(--hover-color);
        text-decoration: underline;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html``;
    }
    return html`
      <div class="org-dropdown-container" @mousedown="${(e) => e.stopPropagation()}">
        <span class='trigger' @click="${() => this.open = !this.open}">
          <bn-icon name="fa fa-ellipsis-h"></bn-icon>
        </span>
        ${renderIf(this.open, html`
          <organization-dropdown-list
            .href="${this.orgChildrenHref}"
            .dest="${this.dest}"
            .organizations="${this.organizations}"
            @organizationclicked="${this._onOrganizationClicked}"
          ></organization-dropdown-list>
        `)}
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this._keyup = this._keyup.bind(this);
    this.close = this.close.bind(this);
    window.addEventListener('keyup', this._keyup);
    document.addEventListener('mousedown', this.close);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('keyup', this._keyup);
    document.removeEventListener('mousedown', this.close);
  }

  close() {
    this.open = false;
  }

  _keyup(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    const childrenHref = this.getHref('https://api.binsentry.com/rel/organization-children');
    if (this.orgChildrenHref !== childrenHref) {
      this.open = false;
      this.orgChildrenHref = childrenHref;
    }
  }

  _onOrganizationClicked({ detail }) {
    this.dispatchEvent(new CustomEvent('organizationclicked', { detail }));
    this.open = false;
  }
}

window.customElements.define('organization-dropdown', OrganizationDropdown);
